import { ValidationError } from "@utils/form"
import * as yup from "yup"

export const GRAPH_TAG_RULES = ["Never", "Always", "More than one"] as const

export const getFormSchema = () => {
  return yup.object({
    rows: yup
      .array()
      .required()
      .of(
        yup.object({
          name: yup.string().required(ValidationError.REQUIRED),
          rule: yup.string().oneOf(GRAPH_TAG_RULES).required(ValidationError.REQUIRED),
          description: yup.string(),
        }),
      )
      .test("unique-name", "", function (rows, ctx) {
        const seen = new Set<string>()
        const duplicates = new Set<string>()

        rows.forEach((row) => {
          if (seen.has(row.name)) {
            duplicates.add(row.name)
          } else {
            seen.add(row.name)
          }
        })

        if (duplicates.size > 0) {
          const duplications = Array.from(duplicates).join(", ")
          return ctx.createError({
            message: `Duplicated "Name" values: ${duplications}`,
          })
        }

        return true
      }),
  })
}
